module.exports = __webpack_public_path__ + "static/img/strona_027.86907f9d.jpg";